import React, { useContext } from 'react';
import { styled, cssMap } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { getIsActivityV3RecentsEnabled } from '@confluence/activity-v3-enabled/entry-points/getIsActivityV3RecentsEnabled';

import { useHeightRef } from '../hooks/useHeightRef';
import { PageCardContext } from '../PageCardContext';
import { PageCardsContext } from '../PageCardsContext';

const EXCERPT_LINE_HEIGHT = 14;
const DEFAULT_NUMBER_OF_LINES = 3;

type ExcerptContainerProps = {
	outerExcerptHeight: number;
};

const styles = cssMap({
	container: {
		flex: '2 0 auto',
		wordWrap: 'break-word',
		marginTop: token('space.200'),
		font: token('font.body.small'),
	},
	text: {
		display: '-webkit-box',
		overflow: 'hidden',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlexibleText = styled.div<ExcerptContainerProps>({
	display: '-webkit-box',
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	WebkitLineClamp: ({ outerExcerptHeight }) => Math.floor(outerExcerptHeight / EXCERPT_LINE_HEIGHT),
	WebkitBoxOrient: 'vertical',
});

export const Excerpt = () => {
	const { width } = useContext(PageCardsContext);
	const { id, excerpt } = useContext(PageCardContext);

	const DEFAULT_EXCERPT_HEIGHT = EXCERPT_LINE_HEIGHT * DEFAULT_NUMBER_OF_LINES;

	const { ref: outerExcerptRef, height: outerExcerptHeight } = useHeightRef(DEFAULT_EXCERPT_HEIGHT);

	return excerpt ? (
		<div css={styles.container} key={`${id}-${width}`} ref={outerExcerptRef}>
			{getIsActivityV3RecentsEnabled() ? (
				<div css={styles.text}>{excerpt}</div>
			) : (
				<FlexibleText outerExcerptHeight={outerExcerptHeight}>{excerpt}</FlexibleText>
			)}
		</div>
	) : null;
};
